import { Dic } from '$utils'
const tableOption = function (that) {
  return {
    add: '新增',
    edit: '修改',
    view: '查看',
    page: true,
    selection: true,
    index: true,
    indexLabel: '序号',
    refreshBtn: false,
    columnBtn: false,
    stripe: true,
    addBtn: false,
    editBtn: false,
    delBtn: false,
    align: 'left',
    size: 'small',
    maxHeight: '100%',
    labelWidth: '100px',
    menuAlign: 'center',
    searchMenuSpan: 6,
    searchBtn: false,
    dialogHeight: 400,
    dialogWidth: '700px',
    emptyText: '暂无数据',
    column: [
      {
        label: '资产类型',
        prop: 'fireassetType',
        type: 'select',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        span: 24,
        dicData: Dic.find('SENU077'),
        align: 'center',
        formatter: function(row, value) {
          return value ? Dic.findByValue('SENU077', value) : ''
        },
        rules: [{ required: true, message: '请选择资产类型', trigger: 'blur' }],
      },
      {
        label: '巡检项',
        prop: 'patrolItem',
        type:'textarea',
        addDisplay: true,
        editDisplay: true,
        viewDisplay: true,
        overHidden: true,
        span: 24,
        rules: [{ required: true, message: '请输入巡检项', trigger: 'blur' }],
      }
    ]
  }
}
export default tableOption